import React, { Component } from 'react'
import Papa from 'papaparse'
import { CellMeasurer, CellMeasurerCache, MultiGrid } from 'react-virtualized'
import Measure from 'react-measure'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import 'react-tabs/style/react-tabs.css'
import * as moment from 'moment'
import Dropdown from 'react-dropdown'
import 'react-dropdown/style.css'
import { Card, Grid } from 'semantic-ui-react'
import 'semantic-ui-css/semantic.min.css'
import './App.css'

const projectFile = '/data/20180531OBSConversionPlanFinal.csv'
const startTime = moment('2018-06-01 08:00', 'YYYY-MM-DD HH:mm')
const endTime = moment('2018-06-08 20:01', 'YYYY-MM-DD HH:mm')
const timeInterval = 15  // 15 minutes
const overrideTimeOffset = 0  // seconds added - matches value on server

const totalDuration = endTime.diff(startTime, 'minutes')
let timeCells = Math.ceil(totalDuration / timeInterval)

const overrideTime = localStorage.getItem('overrideTime')
if (overrideTime) {
  
  //const overrideTimeOffset = startTime.clone().diff(moment(), 'seconds')
  //console.log(overrideTimeOffset)

  // override for time
  moment.now = () => {
      const offset = overrideTimeOffset
      return +new Date(new Date().getTime() + (offset * 1000))
  }

  console.log(
    'overriding current time to:', moment().format('YYYY-MM-DD HH:mm')
  )
}

function clientUrl() {
  if (process.env.NODE_ENV === 'production') {
    return 'https://www.conversionator.biz'
  } else {
    return 'http://localhost:3000'
  }
}

function serverUrl() {
  if (process.env.NODE_ENV === 'production') {
    return 'https://conversionator.technology'
  } else {
    return 'https://conversionator.technology'
    //return 'http://localhost:8000'
  }
}

/*
function toggleOverrideTime() {
  const overrideTime = localStorage.getItem('overrideTime')
  if (overrideTime) {
    localStorage.removeItem('overrideTime')
  } else {
    localStorage.setItem('overrideTime', true)
  }
  window.location.reload()
}
*/

function humanizeDuration(eventDuration) {
  let eventDurationString = ''
  if (eventDuration.days() > 0) {
    eventDurationString += ' ' + moment.duration(eventDuration.days(), 'days') / (60000 * 60 * 24) + ' day' + (moment.duration(eventDuration.days(), 'day') / (60000 * 60 * 24) === 1 ? '' : 's')
  }
      
  if (eventDuration.hours() > 0) {
    eventDurationString += (eventDurationString !== '' ? ', ' : ' ') + moment.duration(eventDuration.hours(), 'hours') / (60000 * 60) + ' hour' + (moment.duration(eventDuration.hours(), 'hours') / (60000 * 60) === 1 ? '' : 's')
  }
      
  if (eventDuration.minutes() > 0) {
    eventDurationString += (eventDurationString !== '' ? ', ' : ' ') + moment.duration(eventDuration.minutes(), 'minutes') / 60000 + ' minute' + (moment.duration(eventDuration.minutes(), 'minutes') / 60000 === 1 ? '' : 's')
  }

  let ret = eventDurationString.trim()

  return (ret !== '' ? ret : '< 1 minute')
}

function humanizeSchedule(eventDiff, duration = false) {
  let status = 'on original schedule'
  let onTime = true
  let eventDuration = moment.duration(eventDiff, 'minutes')
  if (eventDiff > 0) {
    if (duration) {
      status = ' slower than originally scheduled'
    } else {
      status = ' behind original schedule'
    }
    onTime = false
  } else if (eventDiff < 0) {
    if (duration) {
      status = ' faster than originally scheduled'
    } else {
      status = ' ahead of original schedule'
    }
    eventDuration = moment.duration(-eventDiff, 'minutes')
  }

  let eventDurationString = ''
  if (eventDuration.days() > 0) {
    eventDurationString += ' ' + moment.duration(eventDuration.days(), 'days') / (60000 * 60 * 24) + ' day' + (moment.duration(eventDuration.days(), 'day') / (60000 * 60 * 24) === 1 ? '' : 's')
  }
      
  if (eventDuration.hours() > 0) {
    eventDurationString += (eventDurationString !== '' ? ', ' : ' ') + moment.duration(eventDuration.hours(), 'hours') / (60000 * 60) + ' hour' + (moment.duration(eventDuration.hours(), 'hours') / (60000 * 60) === 1 ? '' : 's')
  }
      
  if (eventDuration.minutes() > 0) {
    eventDurationString += (eventDurationString !== '' ? ', ' : ' ') + moment.duration(eventDuration.minutes(), 'minutes') / 60000 + ' minute' + (moment.duration(eventDuration.minutes(), 'minutes') / 60000 === 1 ? '' : 's')
  }

  return [eventDurationString.trim() + status, onTime]
}

function fetchRetry(url, fetchOptions = {}, delay = 4001, limit = 9) {
    return new Promise((resolve, reject) => {
        function success(response) {
            resolve(response)
        }
        function failure(error){
            limit--
            if(limit){
                setTimeout(fetchUrl, delay)
            }
            else {
                // this time it failed for real
                reject(error)
            }
        }
        function finalHandler(finalError){
            throw finalError
        }
        function fetchUrl() {
            return fetch(url, fetchOptions)
                .then(success)
                .catch(failure)
                .catch(finalHandler)
        }
        fetchUrl()
    })
}

function sortBy(type, array, tasks) {
  //console.log(type, array)
  if (array.length < 2) {
    return array
  }
  let header = [array[0]];
  array = array.slice(1, array.length)
  if (type === 'originalStartTime') {
    console.log('sorting by original start time...')
    //console.log(typeof array[0][11])
    array.sort((a, b) => {
      let diff = a[11].diff(b[11])
        //console.log(diff)
      return diff
    })
    //console.log(array)
    return header.concat(array)
  } else if (type === 'startTime') {
    console.log('sorting by scheduled start time...')
    //console.log(typeof array[0][0])
    //console.log(tasks[array[0][0]])
    array.sort((a, b) => {
      let diff = tasks[a[0]].start.diff(tasks[b[0]].start)
        //console.log(diff)
      return diff
    })
    //console.log(array)
    return header.concat(array)
  }
  console.log('sorting by task id...')
  return header.concat(array)
}

let headerRow = ['']
let times = []
let timeIndex = startTime.clone()
while (timeCells > 0) {
  times.push(timeIndex.day())
  if ((timeIndex.hour() === 0) && (timeIndex.minute() === 0)) {
    headerRow.push(timeIndex.format('ddd '))
  } else if (timeIndex.minute() === 0) {
    headerRow.push(timeIndex.format(' ha '))
  } else {
    headerRow.push(timeIndex.format(' m '))
  }
  timeIndex.add(timeInterval, 'minutes')
  timeCells = timeCells - 1
}

const cache = new CellMeasurerCache({
  defaultWidth: 25,
  minWidth: 25,
  fixedHeight: true
})

const cacheTwo = new CellMeasurerCache({
  defaultWidth: 100,
  minWidth: 60,
  fixedHeight: true
})

const TaskDetails = ({
  taskId, name, category, owner, prerequisites, followUps, startTime, endTime,
  duration, scheduledStartTime, realizedStartTime, startSchedule,
  scheduledEndTime, realizedEndTime, endSchedule, scheduledDuration,
  realizedDuration, durationSchedule, taskReady, taskStarted, taskCompleted,
  onTaskStarted, onTaskCompleted, people, subscribers, hasSubscribed,
  taskSubscribed, notes, onTaskSelected}) => {
  const categoryColorMap = {
    'Accounting': 'springGreen',
    'IT': 'slateBlue',
    'Parts': 'gold',
    'Rental': 'tomato',
    'Sales': 'mediumSeaGreen',
    'Cron': 'lightSlateGray',
    'Service': 'dodgerBlue',
    'Warranty': 'mediumOrchid ',
    'Credit': 'pink',
    '': 'white',
    '(no category)': 'lightGrey'
  }

  const prerequisitesButtons = (
    prerequisites.length ?
    prerequisites.sort(
      (a, b) => (a - b)
    ).map(
      (d, i) => 
        <span
          key={i}
          onClick={
            () => {onTaskSelected(d)
          }
        }>
          <u>{d}</u>
        </span>
      
    ).reduce(
      (a, b) => [a, ', ', b]
    ) :
    'none'
  )

  const followUpsButtons = (
    followUps.length ?
    followUps.sort(
      (a, b) => (a - b)
    ).map(
      (d, i) => 
        <span
          key={i}
          onClick={
            () => {onTaskSelected(d)
          }
        }>
          <u>{d}</u>
        </span>
      
    ).reduce(
      (a, b) => [a, ', ', b]
    ) :
    'none'
  )

  return (
    <Card fluid>
      <Card.Header>Task #{taskId}: <b>{name}</b></Card.Header>
      <div style={{paddingTop: '20px', paddingBottom: '20px'}} >
        <Grid>
          <Grid.Row stretched>
            <Grid.Column width={1} />
            <Grid.Column width={7}>
              {(
                taskCompleted ?
                <button style={{background: 'lightGreen'}} className={'button'}
                >
                  Task complete!
                </button> :
                (
                  taskReady ?
                  (
                    taskStarted ?
                    <button
                      style={{background: 'cyan'}}
                      className={'button'}
                      onClick={onTaskCompleted}
                    >
                      Mark task as completed
                    </button> :
                    <button
                      style={{background: 'magenta'}}
                      className={'button'}
                      onClick={onTaskStarted}
                    >
                      Mark task as started
                    </button>
                  ) :
                  <button style={{background: 'orange'}} className={'button'}>
                    Must complete prerequisites first
                  </button>
                ) 
              )}
            </Grid.Column>                
            <Grid.Column width={7}>
              <Dropdown options={Object.keys(people).sort().map(person => {
                return ({
                  value: person,
                  label: hasSubscribed(person, owner, subscribers)
                })
              })} onChange={taskSubscribed} value={'Set event subscribers'} />
            </Grid.Column>
            <Grid.Column width={1} />
          </Grid.Row>
          <Grid.Row stretched>
            <Grid.Column textAlign={'left'} width={3}>
              <div style={{backgroundColor: (category ? categoryColorMap[category]: 'white')}} >
                &nbsp;&nbsp;Category: {category}
              </div>
            </Grid.Column>
            <Grid.Column textAlign={'left'} width={3}>
              Owner: {owner}
            </Grid.Column> 
            <Grid.Column textAlign={'left'} width={5}>
              <div style={{display: 'inline-block'}}>
                Prerequisites: {prerequisitesButtons}
              </div>
            </Grid.Column>                
            <Grid.Column textAlign={'left'} width={5}>
              <div style={{display: 'inline-block'}}>
                Follow-up tasks: {followUpsButtons}
              </div>
            </Grid.Column>             
          </Grid.Row>
          <Grid.Row stretched>
            <Grid.Column textAlign={'left'} width={6}>
              &nbsp;&nbsp;Scheduled Start: {startTime}
            </Grid.Column>
            <Grid.Column textAlign={'left'} width={5}>
              &nbsp;End: {endTime}
            </Grid.Column> 
            <Grid.Column textAlign={'left'} width={5}>
              &nbsp;Duration: {duration}
            </Grid.Column>              
          </Grid.Row>   
          <Grid.Row stretched>
            <Grid.Column textAlign={'left'} width={6}>
              &nbsp;&nbsp;Original Start: &nbsp;{scheduledStartTime}
            </Grid.Column>
            <Grid.Column textAlign={'left'} width={5}>
              &nbsp;End: {scheduledEndTime}
            </Grid.Column> 
            <Grid.Column textAlign={'left'} width={5}>
              &nbsp;Duration: {scheduledDuration}
            </Grid.Column>              
          </Grid.Row>          
          <Grid.Row stretched>
            <Grid.Column textAlign={'left'} width={6}>
              &nbsp;&nbsp;Realized Start: {(
                taskStarted ? realizedStartTime : '...')}
            </Grid.Column>
            <Grid.Column textAlign={'left'} width={5}>
              &nbsp;End: {(taskCompleted ? realizedEndTime : '...')}
            </Grid.Column>     
            <Grid.Column textAlign={'left'} width={5}>
              &nbsp;Duration: {(taskCompleted ? realizedDuration : '...')}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row stretched>
            <Grid.Column textAlign={'left'} width={6}>
              <div style={{background: (startSchedule[1] ? 'lightGreen' : 'red')}}>
                &nbsp;&nbsp;{startSchedule[0]}
              </div>
            </Grid.Column>             
            <Grid.Column textAlign={'left'} width={5}>
              <div style={{background: (endSchedule[1] ? 'lightGreen' : 'red')}}>
                &nbsp;{endSchedule[0]}
              </div>
            </Grid.Column>     
            <Grid.Column textAlign={'left'} width={5}>
              <div style={{background: (durationSchedule[1] ? 'lightGreen' : 'red')}}>
                &nbsp;{durationSchedule[0]}
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row stretched>
            <Grid.Column textAlign={'left'} width={16}>
              &nbsp;&nbsp;Notes: {notes}
            </Grid.Column> 
          </Grid.Row>
        </Grid>
      </div>
    </Card>
  )
}

const CategoryTab = ({
  categories, tasks, people, hasSubscribed, categorySubscribed}) => {
  categories = Array.from(categories).sort()

  const categoryColorMap = {
    'Accounting': 'springGreen',
    'IT': 'slateBlue',
    'Parts': 'gold',
    'Rental': 'tomato',
    'Sales': 'mediumSeaGreen',
    'Cron': 'lightSlateGray',
    'Service': 'dodgerBlue',
    'Warranty': 'mediumOrchid ',
    'Credit': 'pink',
    '': 'white',
    '(no category)': 'lightGrey'
  }

  return (
    <Card fluid>
      <div style={{paddingTop: '20px', paddingBottom: '20px'}} >
        <Grid>
          {categories.map((category, index) => {
            
            const total = Object.values(tasks).filter(t => {
              return (
                t.category === category
              )
            }).length
            
            const fraction = Object.values(tasks).filter(t => {
              return (
                t.completed && (t.category === category)
              )
            }).length

            const percentage = String(Math.floor(100 * fraction / total))        

            return (
              <Grid.Row stretched key={index}>
                <Grid.Column width={1} />
                <Grid.Column width={4} >
                  <div style={{height: '36.84px', lineHeight: '36.84px', textAlign: 'center', backgroundColor: (category ? categoryColorMap[category]: 'white')}} >
                    {category}
                  </div>
                </Grid.Column>
                <Grid.Column width={1} />
                <Grid.Column width={4} textAlign={'left'} >
                  <div style={{height: '36.84px', lineHeight: '36.84px', textAlign: 'center'}} >
                    {percentage + '% complete (' + fraction + '/' + total +
                     ' tasks completed)'}
                  </div>
                </Grid.Column>   
                <Grid.Column width={1} />  
                <Grid.Column width={4}>
                  <Dropdown
                    options={Object.keys(people).sort().map(person => {
                      return ({
                        value: person,
                        label: hasSubscribed(person, category, tasks)
                      })
                    })}
                    onChange={person => categorySubscribed(person, category)}
                    value={'Subscribe to category'}
                  />
                </Grid.Column>
                <Grid.Column width={1} />
              </Grid.Row>
            )
          })}
        </Grid>
      </div>
    </Card>
  )
}

class App extends Component {
  constructor(props, context) {
    super(props, context)

    let data = [headerRow]
    let originalData = [['taskId', 'category', 'name', 'person', 'start',
                         'finish', 'prerequisites', 'description', 'manual']]

    this.cellRenderer = this.cellRenderer.bind(this)
    this.taskCellRenderer = this.taskCellRenderer.bind(this)
    this.onCellClick = this.onCellClick.bind(this)
    this.onRowClick = this.onRowClick.bind(this)
    this.onTaskClick = this.onTaskClick.bind(this)
    this.onStart = this.onStart.bind(this)
    this.onCompleted = this.onCompleted.bind(this)
    this.onSelectPerson = this.onSelectPerson.bind(this)
    this.onSelectCategory = this.onSelectCategory.bind(this)
    this.togglePreCheckbox = this.togglePreCheckbox.bind(this)
    this.togglePostCheckbox = this.togglePostCheckbox.bind(this)
    this.toggleReadyCheckbox = this.toggleReadyCheckbox.bind(this)
    this.fetchTasks = this.fetchTasks.bind(this)
    this.reconcileWithServer = this.reconcileWithServer.bind(this)
    this.hardReset = this.hardReset.bind(this)
    this.isSubscribedToTask = this.isSubscribedToTask.bind(this)
    this.isSubscribedToCategory = this.isSubscribedToCategory.bind(this)
    this.onSubscribe = this.onSubscribe.bind(this)
    this.onSubscribeToCategory = this.onSubscribeToCategory.bind(this)
    this.isFiltered = this.isFiltered.bind(this)
    this.drawBoard = this.drawBoard.bind(this)
    this.findAvailableTime = this.findAvailableTime.bind(this)
    this.bumpTaskForward = this.bumpTaskForward.bind(this)
    this.moveTaskBack = this.moveTaskBack.bind(this)
    this.toggleNoCompletedCheckbox = this.toggleNoCompletedCheckbox.bind(this)
    this.sortByStart = this.sortByStart.bind(this)
    this.sortByOriginalStart = this.sortByOriginalStart.bind(this)

    this.state = {
      serverData: {loaded: false},
      data: data,
      people: {},
      categories: new Set(),
      tasks: {},
      originalData: originalData,
      categoryFilteredData: originalData,
      filteredData: originalData,
      sortedData: sortBy('taskId', originalData, {}),
      currentTask: null,
      dimensions: {
        width: -1,
        height: -1
      },
      colorMap: {
        'alt': 'lightGrey',
        'top': 'grey',
        'highlight': 'yellow',
        'thursday': 'violet',
        'friday': 'lightGreen',
        'sunday': 'orange',
        'tuesday': 'pink',
        0: 'white',
        1: 'red',
        2: 'skyBlue',
        3: 'green',
        'Accounting': 'springGreen',
        'IT': 'slateBlue',
        'Parts': 'gold',
        'Rental': 'tomato',
        'Sales': 'mediumSeaGreen',
        'Cron': 'lightSlateGray',
        'Service': 'dodgerBlue',
        'Warranty': 'mediumOrchid ',
        'Credit': 'pink',
        '': 'white',
        '(no category)': 'lightGrey'
      },
      nonce: 0,
      categoryFilter: null,
      personFilter: null,
      categoryFilters: new Set(),
      personFilters: new Set(),
      includePre: false,
      includePost: false,
      readyOnly: false,
      refreshId: 0,
      //sortType: 'taskId'
      sortType: 'taskId',
      noCompleted: false,
      sortByStart: false,
      sortByOriginalStart: false
    }
  }

  componentDidMount() {
    let people = {}
    const extraPeople = [
      'Lynn', 'Denise', 'Jim S.', 'Jessica', 'Jeff Hess', 'Jennifer Brenay',
      'Steve Fletcher', 'Maurine Wilson', 'Kortney Trahey', 'Alec', 'Josh House',
      'Paul Woods', 'Roger Bennett'
    ]
    let categories = new Set()
    let tasks = {}

    this.fetchTasks()
    const refreshId = setInterval(() => this.fetchTasks(), 5000)
    
    setInterval(() => {
      //const now = moment()
      //Object.values(tasks).filter(t => {
      //  return (
      //    now.diff(t.start, 'minutes') > 0
      //  )
      //}).slice().reverse().forEach(t => {
      //  this.bumpTaskForward(t)
      //})

      Object.values(tasks).forEach(t => {
        this.bumpTaskForward(t)
        this.moveTaskBack(t.taskId, tasks)

        t.startSchedule = humanizeSchedule(
          t.start.diff(
            t.originalStart, 'minutes'
          )
        )

        t.finishSchedule = humanizeSchedule(
          t.finish.diff(
            t.originalFinish, 'minutes'
          )
        )

        t.durationSchedule = t.duration - t.originalDuration
      })
    }, 501)

    setInterval(() => {
      this.setState({
        sortedData: sortBy(this.state.sortType, this.state.filteredData, this.state.tasks)
      })
    }, 30001)

    Papa.parse(clientUrl() + projectFile, {
      download: true,
      complete: (results) => {
        // get all tasks and people from returned project file
        let names = new Set()
        results.data.forEach((i, index) => {
          if ((index > 0) && (i.length > 1)) {
            const taskId = i[0]
            const cleanReqs = i[6].split(' ').join('').split(',').filter(String)
            tasks[taskId] = {
              taskId: parseInt(i[0], 10),
              category: i[1],
              name: i[2],
              person: i[3], 
              start: moment(i[4], 'LLL'),
              originalStart: moment(i[4], 'LLL'),
              startSchedule: ['on schedule', true],
              finish: moment(i[5], 'LLL'),
              originalFinish: moment(i[5], 'LLL'),
              finishSchedule: ['on schedule', true],
              duration: moment(i[5], 'LLL')
                        .diff(moment(i[4], 'LLL'), 'minutes'),
              originalDuration: moment(i[5], 'LLL')
                                .diff(moment(i[4], 'LLL'), 'minutes'),
              durationSchedule: ['on schedule', true],
              prerequisites: Array.from(cleanReqs, i => parseInt(i, 10)),
              isPrerequisiteOf: [],
              description: i[7],
              ready: (cleanReqs.length === 0),
              started: false,
              completed: false,
              subscribers: new Set(),
              manual: (i[8] === 'True')
            }
            //console.log(tasks[taskId])

            i.pop()

            const name = i[3]
            names.add(name)

            i.push(cleanReqs.length === 0 ? 'yes' : 'no')
            i.push('no')
            i.push('no')
            i.push(moment(i[4], 'LLL'))
            i.push(moment(i[5], 'LLL'))
          } else {
            i.pop()
            i.push('Ready')
            i.push('Started')
            i.push('Completed')
            i.push('Original Start')
            i.push('Original Finish')
          }
        })

        extraPeople.forEach(p => {
          names.add(p)
        })

        names.forEach(n => {
          people[n] = []
        })

        results.data.forEach((i, index) => {
          if ((index > 0) && (i.length > 6)) {
            const x = i[0]
            const person = i[3]
            people[person].push(x)
          }
        })

        // clear out empty row at the end
        results.data.pop()

        // find and populate categories and `isPrerequisiteOf` values
        Object.values(tasks).forEach((t) => {
          categories.add(t.category)
          t.prerequisites.forEach((p) => {
            if (p in tasks === false) {
              console.log(`we've got a problem... task ${t.taskId} has a prerequisite task ${p} that isn't found via tasks[p]!`)
            } else {
              tasks[p].isPrerequisiteOf.push(t.taskId)
            }
          })
        })

        this.setState({
          people: people,
          categories: categories,
          tasks: tasks,
          originalData: results.data,
          filteredData: results.data,
          categoryFilteredData: results.data,
          sortedData: sortBy(this.state.sortType, results.data, tasks)
        })

        this.drawBoard(people, tasks)
      }
    })

    this.setState({
      refreshId: refreshId
    })
  }

  drawBoard(people, tasks) {
    //console.log('drawing board...')
    const data = [headerRow].concat(
      Object.keys(people).sort().map(person => {
        let row = new Array(1 + timeCells)
        //row[0] = person
        people[person].slice().reverse().forEach((t) => {
          const taskStartOffset = tasks[t].start.diff(startTime, 'minutes')
          const firstTaskCell = Math.floor(taskStartOffset / timeInterval)
          const taskDuration = tasks[t].finish.diff(tasks[t].start, 'minutes')
          
          let taskCells = Math.ceil(taskDuration / timeInterval)
          let x = 1
          if (row[firstTaskCell + x] in tasks &&
              tasks[row[firstTaskCell + x]].completed === false &&
              tasks[row[firstTaskCell + x]].started === true) {
            //console.log('skipping', t, 'because', row[firstTaskCell + x], 'is in progress.')
          } else if (row[firstTaskCell + x] in tasks &&
                     tasks[row[firstTaskCell + x]].completed === false &&
                     tasks[t].completed === true) {
            //console.log('skipping', t, 'because it is complete but', row[firstTaskCell + x], 'is incomplete')
          } else {
            row[firstTaskCell + x] = t
          }
          while (taskCells > 1) {
            x++
            if (row[firstTaskCell + x] in tasks &&
                tasks[row[firstTaskCell + x]].completed === false &&
                tasks[row[firstTaskCell + x]].started === true) {
              //console.log('skipping', t, 'because', row[firstTaskCell + x], 'is in progress.')
            } else if (row[firstTaskCell + x] in tasks &&
                       tasks[row[firstTaskCell + x]].completed === false &&
                       tasks[t].completed === true) {
              //console.log('skipping', t, 'because it is complete but', row[firstTaskCell + x], 'is incomplete')
            } else {
              row[firstTaskCell + x] = t
            }
            taskCells--
          }
        })
        // draw the person's name last
        row[0] = person
        return row
      })
    )

    this.setState({
      data: data
    })
  }

  bumpTaskForward(task, fromTime = false) {
    if (task.completed === true) {
      return
    } else if (task.started !== true) {
      let bumpForward = 0
      if (fromTime === false) {
        bumpForward = moment().diff(task.start, 'minutes')
      } else {
        bumpForward = fromTime.diff(task.start, 'minutes')
      }
      
      if (bumpForward > 0) {
        //bumpForward = 15 + (Math.floor(bumpForward / 15) * 15)
        //console.log('bumping forward', task.taskId, 'by', bumpForward, 'minutes.')
        task.start.add(moment.duration(bumpForward, 'minutes'))
        task.finish.add(moment.duration(bumpForward, 'minutes'))
        
        const tasks = this.state.tasks
        tasks[task.taskId] = task
        this.setState({
          tasks: tasks
        }, () => {
          task.isPrerequisiteOf.forEach(t => {
            this.bumpTaskForward(tasks[t], task.finish)
          })
        })
      //} else {
      //  console.log('no need to bump task', task.taskId, 'start time forward.')
      }
    // next, check if the task is started but not finished
    } else if (task.started === true && task.completed !== true) {
      let bumpForward = 0
      if (fromTime === false) {
        bumpForward = moment().diff(task.finish, 'minutes')
      } else {
        bumpForward = fromTime.diff(task.finish, 'minutes')
      }

      if (bumpForward > 0) {
        //bumpForward = 15 + (Math.floor(bumpForward / 15) * 15)
        //console.log('bumping forward', task.taskId, ' finish time by', bumpForward, 'minutes.')
        task.finish = task.finish.clone().add(moment.duration(bumpForward, 'minutes'))
        task.duration = task.finish.diff(task.start, 'minutes')
        
        const tasks = this.state.tasks
        tasks[task.taskId] = task
        this.setState({
          tasks: tasks
        }, () => {
          task.isPrerequisiteOf.forEach(t => {
            this.bumpTaskForward(tasks[t], task.finish)
          })
        })
      //} else {
      //  console.log('no need to bump task', task.taskId, 'finish time forward.')
      }
    }
  }

  moveTaskBack(taskId, tasks) {
    if (tasks[taskId].started !== true &&
        tasks[taskId].prerequisites.length === 0) {
      //console.log('', taskId, 'has no prerequisites.')
      //tasks[taskId].start = tasks[taskId].originalStart.clone()
      //tasks[taskId].finish = tasks[taskId].originalFinish.clone()
      //  this.setState({
      //    tasks: tasks
      //  })
      return
    } else if (tasks[taskId].started !== true &&
               tasks[taskId].manual === true) {
      return
    } else {
      tasks[taskId].isPrerequisiteOf.forEach(t => {
        const availableTime = this.findAvailableTime(tasks[t])
        //console.log(taskId, t, availableTime)
        
        if (availableTime > 0 && tasks[t].started !== true && tasks[t].manual !== true) {
          tasks[t].start = tasks[t].start.clone().subtract(moment.duration(availableTime, 'minutes'))
          tasks[t].finish = tasks[t].start.clone().add(tasks[t].duration, 'minutes')
          this.setState({
            tasks: tasks
          }, () => {
            if (tasks[t].prerequisites.length > 0 && tasks[t].manual !== true) {
              this.moveTaskBack(t, tasks)
            }
          })
        }
      })
    }
  }

  findAvailableTime(task) {
    let time = null
    let allComplete = true
    //console.log(task.taskId, task.prerequisites.length)
    task.prerequisites.forEach(p => {

      const preTask = this.state.tasks[p]
      if (typeof pretask !== 'undefined') {
        console.log(`we've got a problem... task ${task.taskId} has a prerequisite task ${p} that isn't found via tasks[p]!`)
      } else if (preTask.completed === false) {
        allComplete = false
        const candidateTime = task.start.diff(preTask.finish, 'minutes')
        if (time === null || candidateTime <= time) {
          time = candidateTime
        }
      }
    })

    let timeRoundedUp = 0
    if (allComplete) {
      time = task.start.diff(moment(), 'minutes')
      //timeRoundedUp = time - (time % timeInterval)
      timeRoundedUp = time
      //console.log('', task.taskId, 'ready now, can be moved back by', timeRoundedUp, 'minutes!')
    } else if (time !== null && time > 0) {
      //timeRoundedUp = time - (time % timeInterval)
      timeRoundedUp = time
      //console.log('', task.taskId, 'can be moved back by', timeRoundedUp, 'minutes!')
    }
    return timeRoundedUp
  }

  fetchTasks() {
    fetch(serverUrl() + '/tasks', {
      cache: 'no-cache'  // expects ETags and If-Modified-Since / If-None-Match
    })
    .then(results => {
      return results.json()
    }).then(data => {
      if (data !== this.state.serverData) {
        this.setState({
          serverData: data
        }, () => {
          if (Object.values(data).map(v => {
            return (v.subscribers.length === 0)
          }).every(i => {return i})) {
            console.log('Setting up task owners as subscribers...')
            Object.values(this.state.tasks).forEach(v => {
              this.onSubscribe({value: v.person}, v.taskId)
            })
          }
          this.reconcileWithServer()
        })
      }
    }).catch(error => {
        console.error(error)
    })
  }

  hardReset() {
    if (window.confirm('Are you sure you want to delete all data?')) {
      clearInterval(this.state.refreshId)

      fetch(serverUrl() + '/tasks', {
        method: 'delete'
      }).then(response => {
        console.log(response.json())
      }).catch(error => {
          console.error(error)
      })

      window.location.reload()
    }    
  }

  reconcileWithServer() {
    Object.values(this.state.serverData).forEach((v, vIndex) => {
      let tasks = this.state.tasks
      let originalData = this.state.originalData

      if (!(v.taskId in tasks)) {       
        return // don't include tasks that have been added that aren't original
      }

      tasks[v.taskId].subscribers = new Set(v.subscribers)
      this.setState({
        tasks: tasks
      })

      //let willUpdate = false
      if (v.started === true && tasks[v.taskId].started === false) {
        //willUpdate = true

        tasks[v.taskId].started = true
        tasks[v.taskId].start = moment.unix(v.startedTime)
        if (v.completed !== true) {
          tasks[v.taskId].finish = tasks[v.taskId].start.clone().add(tasks[v.taskId].duration, 'minutes')
        }
        //console.log(tasks[v.taskId].start.format('ddd YYYY-MM-DD h:mm:dd a'))
        tasks[v.taskId].startSchedule = humanizeSchedule(
          tasks[v.taskId].start.diff(
            tasks[v.taskId].originalStart, 'minutes'
          )          
        )
        // todo: reschedule .finish based on .duration

        const startedIndex = originalData.map((n) => n[0]).indexOf(String(v.taskId))
        originalData[startedIndex][9] = 'yes'

        this.setState({
          tasks: tasks,
          originalData: originalData,
          nonce: this.state.nonce + 1
        }, () => {
          if (tasks[v.taskId].prerequisites.length > 0) {
            this.moveTaskBack(v.taskId, tasks)
          }
        })
      }

      if (v.completed === true && tasks[v.taskId].completed === false) {
        //willUpdate = true
        tasks[v.taskId].completed = true
        tasks[v.taskId].finish = moment.unix(v.completedTime)
        tasks[v.taskId].finishSchedule = humanizeSchedule(
          tasks[v.taskId].finish.diff(
            tasks[v.taskId].originalFinish, 'minutes'
          )
        )
        tasks[v.taskId].duration = tasks[v.taskId].finish
                                   .diff(tasks[v.taskId].start, 'minutes')
        tasks[v.taskId].durationSchedule = tasks[v.taskId].duration - tasks[v.taskId].originalDuration

        // figure out and assign other task.ready values
        tasks[v.taskId].isPrerequisiteOf.forEach(t => {
          let isReady = true
          tasks[t].prerequisites.forEach((p) => {
            if (tasks[p].completed === false) {
              isReady = false
            }
          })

          if (isReady === true) {
            //// send a `ready` event to the server
            //fetchRetry(serverUrl() + '/events', {
            //  cache: 'no-cache',  // expects ETags and If-Modified-Since / If-None-Match
            //  method: 'put',
            //  headers: {
            //    'Content-Type': 'application/json'
            //  },
            //  body: JSON.stringify({taskId: t, event: 'ready'})
            //}).then(response => {
            //  //console.log(response.json())
            //}).catch(error => {
            //  console.error(error)
            //})

            tasks[t].ready = true
            // todo: reschedule .start based on current time & manual scheduling

            const index = originalData.map((n) => n[0]).indexOf(String(t))
            originalData[index][8] = 'yes'
          }
        })

        const completedIndex = originalData.map((n) => n[0]).indexOf(String(v.taskId))
        originalData[completedIndex][10] = 'yes'

        this.setState({
          tasks: tasks,
          originalData: originalData,
          nonce: this.state.nonce + 1
        }, () => {
          if (tasks[v.taskId].prerequisites.length > 0) {
            this.moveTaskBack(v.taskId, tasks)
          }
          this.onSelectPerson(this.state.personFilter ? this.state.personFilter : {value: 'No filter', label: 'No filter'}, false)
          
        })
      }
    })
    this.drawBoard(this.state.people, this.state.tasks)
  }

  cellRenderer ({ columnIndex, key, parent, rowIndex, style }) {
    let cell = this.state.data[rowIndex][columnIndex]
    if (cell === undefined) {
      return ''
    }

    if (rowIndex === 0 && columnIndex === 0) {
      let backgroundColor = 'lightGrey'
      if (moment().day() === 4) {
        backgroundColor = 'violet'      
      } else if (moment().day() === 5) {
        backgroundColor = 'lightGreen'
      } else if (moment().day() === 6) {
        backgroundColor = 'skyBlue'
      } else if (moment().day() === 0) {
        backgroundColor = 'orange'
      } else if (moment().day() === 1) {
        backgroundColor = 'yellow'
      } else if (moment().day() === 2) {
        backgroundColor = 'pink'
      }
      return (
        <CellMeasurer
          cache={cache}
          columnIndex={columnIndex}
          key={key}
          parent={parent}
          rowIndex={rowIndex}
        >        
          <div 
          key={key}
          style={{
            background: backgroundColor,
            display: 'flex',
            justifyContent: 'center'
          }}>
            {moment().format('ddd hh:mm a')}
          </div>
        </CellMeasurer>
      )
    }

    let category = null
    if (rowIndex === 0) {
      if (times[columnIndex - 1] === 4) {
        category = 'thursday'
      } else if (times[columnIndex - 1] === 5) {
        category = 'friday'
      } else if (times[columnIndex - 1] === 6) {
        category = 2
      } else if (times[columnIndex - 1] === 0) {
        category = 'sunday'
      } else if (times[columnIndex - 1] === 1) {
        category = 'highlight'
      } else if (times[columnIndex - 1] === 2) {
        category = 'tuesday'
      } else {
        category = 'top'
      }
    } else if (columnIndex === 0) {
      category = 'top'
    } else if (this.state.tasks[cell].completed) {
      category = 'alt'
    } else {
      category = this.state.tasks[parseInt(cell, 10)].category  
    }

    const color = this.state.colorMap[category]

    return (
      <CellMeasurer
        cache={cache}
        columnIndex={columnIndex}
        key={key}
        parent={parent}
        rowIndex={rowIndex}
      >       
        <div
          key={key}
          style={{
            ...style,
            boxShadow: (
              (
                this.state.tasks[cell] &&
                this.state.tasks[cell].started &&
                !this.state.tasks[cell].completed
              ) ?
              'inset 0 0 0 10px magenta':
              'inherit'),
            height: 25,
            whiteSpace: 'pre'
          }}
          onClick={(e) => this.onCellClick(e, rowIndex, columnIndex)}
        >
          <div style={{background: color, color: (this.state.data[rowIndex][columnIndex - 1] === cell ? color : 'black')}}>
            {cell}
          </div>
        </div>
      </CellMeasurer>
    )  
  }
 
  taskCellRenderer ({ columnIndex, key, parent, rowIndex, style }) {
    const columnShuffle = {
      0: 0,
      1: 1,
      2: 8,
      3: 9,
      4: 10,
      5: 2,
      6: 3,
      7: 4,
      8: 5,
      9: 11,
      10: 12,
      11: 6,
      12: 7
    }

    const dayColorer = (time, day) => {
      const colorMap = this.state.colorMap

      if (day === 4) {
        category = 'thursday'
      } else if (day === 5) {
        category = 'friday'
      } else if (day === 6) {
        category = 2
      } else if (day === 0) {
        category = 'sunday'
      } else if (day === 1) {
        category = 'highlight'
      } else if (day === 2) {
        category = 'tuesday'
      } else {
        category = 'top'
      }   

      return (
        <div style={{width: '100%', backgroundColor: colorMap[category]}}>
          {time}
        </div>
      )
    }

    const dangerZone = (name, ready, completed, finish, originalFinish, isPrerequisiteOf, skipLog, taskId) => {
      if (ready === true && completed === false && finish.diff(originalFinish) > 0) {
        if (
          isPrerequisiteOf.length > 0 &&
          isPrerequisiteOf.some((futureTaskId) => {
            if (this.state.tasks[futureTaskId].person === this.state.tasks[taskId].person) {
              return false
            }

            let futureDangerZone = this.state.tasks[futureTaskId].finish.diff(this.state.tasks[futureTaskId].originalFinish) > 0
            if (futureDangerZone === true && skipLog === false) {
              console.log(`${taskId} (${name}) is holding back ${this.state.tasks[futureTaskId].person} from starting ${this.state.tasks[futureTaskId].taskId} => ${this.state.tasks[futureTaskId].name}`)
            }
            return futureDangerZone
          })
        ) {
          return (
          <span style={{color: 'red'}}>
            <b>
              {name}
            </b>
          </span>
          )          
        }

        return (
        <span style={{color: 'red'}}>
          {name}
        </span>
        )
      }
      return name
    }

    const columnGetter = columnShuffle[columnIndex]

    let cell = this.state.sortedData[rowIndex][columnGetter]

    //if ( rowIndex > 0 && (columnGetter === 4 || columnGetter === 5)) {
    //  cell = moment(cell, 'LLL').format('ddd h:mm a')
    //}
    if (rowIndex > 0) {
      const cellId = this.state.sortedData[rowIndex][0]
      //console.log(cellId)
      if (columnGetter === 4) {
        cell = dayColorer(
          this.state.tasks[cellId].start.format('ddd h:mm a'),
          this.state.tasks[cellId].start.day()
        ) 
      } else if (columnGetter === 5) {
        cell = dayColorer(
          this.state.tasks[cellId].finish.format('ddd h:mm a'),
          this.state.tasks[cellId].finish.day()
        )
      } else if (columnGetter === 11) {
        cell = dayColorer(
          this.state.tasks[cellId].originalStart.format('ddd h:mm a'),
          this.state.tasks[cellId].originalStart.day()
        ) 
      } else if (columnGetter === 12) {
        cell = dayColorer(
          this.state.tasks[cellId].originalFinish.format('ddd h:mm a'),
          this.state.tasks[cellId].originalFinish.day()
        )
      } else if (columnGetter === 2 || columnGetter === 3) {
        cell = dangerZone(
          cell,
          this.state.tasks[cellId].ready,
          this.state.tasks[cellId].completed,
          this.state.tasks[cellId].finish,
          this.state.tasks[cellId].originalFinish,
          this.state.tasks[cellId].isPrerequisiteOf,
          columnGetter === 2,
          cellId
        )
      }
    }

    let category = this.state.sortedData[rowIndex][1]
    
    if (rowIndex === 0) {
      category = 'top'
    } else if (columnIndex === 0) {
      if (this.state.currentTask && (String(this.state.currentTask.taskId) === cell)) {
        category = 'highlight'
      } else if (category in this.state.colorMap) {
        // keep category the same
      } else {
        category = 'top'
      }
    } else if (columnGetter > 7) {
      if (cell === 'yes') {
        category = 3
      } else {
        category = 1
      }
    }

    let color = 'white'
    if (columnIndex < 2 | rowIndex < 1 | columnGetter > 7) {
      color = this.state.colorMap[category]
    }

    return (
      <CellMeasurer
        cache={cacheTwo}
        columnIndex={columnIndex}
        key={key}
        parent={parent}
        rowIndex={rowIndex}
      >         
        <div
          key={key}
          style={style}
          onClick={(e) => this.onRowClick(e, rowIndex)}
        >
          <div style={{background: color, whiteSpace: 'nowrap'}}>
            {cell}
          </div>
        </div>
      </CellMeasurer>
    )  
  }

  onCellClick(e, rowIndex, columnIndex) {
    if (rowIndex && columnIndex) {
      const task = this.state.data[rowIndex][columnIndex]
      if (task) {
        this.setState({
          currentTask: this.state.tasks[task]
        })
      }
    }
  }

  onRowClick(e, rowIndex) {
    if (rowIndex) {
      const task = this.state.sortedData[rowIndex][0]
      if (task) {
        this.setState({
          currentTask: this.state.tasks[task]
        })
      }
    }
  }

  onTaskClick(taskId) {
    //console.log(taskId)
    if (taskId !== 'none') {
      this.setState({
        currentTask: this.state.tasks[taskId]
      })
    }
  }

  onStart(e) {
    const startId = this.state.currentTask.taskId

    fetchRetry(serverUrl() + '/tasks', {
      cache: 'no-cache',  // expects ETags and If-Modified-Since / If-None-Match
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({taskId: startId, started: true})
    }).then(response => {
      //console.log(response.json())
    }).catch(error => {
        console.error(error)
    })

    let originalData = this.state.originalData

    let tasks = this.state.tasks
    tasks[startId].started = true
    tasks[startId].start = moment()
    //console.log('started:',tasks[startId].start.format('ddd YYYY-MM-DD h:mm:dd a'))
    tasks[startId].finish = tasks[startId].start.clone().add(tasks[startId].duration, 'minutes')
    //console.log('new finish est:', tasks[startId].finish.format('ddd YYYY-MM-DD h:mm:dd a'))
    tasks[startId].startSchedule = humanizeSchedule(
      tasks[startId].start.diff(
        tasks[startId].originalStart, 'minutes'
      )
    )
    // todo: reschedule .finish based on .duration

    const startedIndex = originalData.map((n) => n[0]).indexOf(String(startId))
    originalData[startedIndex][9] = 'yes'

    this.setState({
      tasks: tasks,
      originalData: originalData,
      nonce: this.state.nonce + 1
    }, () => {
      if (tasks[startId].prerequisites.length > 0) {
        this.moveTaskBack(startId, tasks)
      }
      this.drawBoard(this.state.people, this.state.tasks)
    })
  }

  onCompleted(e) {
    const completedId = this.state.currentTask.taskId

    fetchRetry(serverUrl() + '/tasks', {
      cache: 'no-cache',  // expects ETags and If-Modified-Since / If-None-Match
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({taskId: completedId, completed: true})
    }).then(response => {
      //console.log(response.json())
    }).catch(error => {
        console.error(error)
    })

    let originalData = this.state.originalData

    let tasks = this.state.tasks
    tasks[completedId].completed = true
    tasks[completedId].finish = moment()
    tasks[completedId].finishSchedule = humanizeSchedule(
      tasks[completedId].finish.diff(
        tasks[completedId].originalFinish, 'minutes'
      )
    )

    tasks[completedId].duration = tasks[completedId].finish
                                  .diff(tasks[completedId].start, 'minutes')
    tasks[completedId].durationSchedule = tasks[completedId].duration - tasks[completedId].originalDuration

    // figure out and assign other task.ready values
    tasks[completedId].isPrerequisiteOf.forEach(t => {
      let isReady = true
      tasks[t].prerequisites.forEach((p) => {
        if (tasks[p].completed === false) {
          isReady = false
        }
      })
      if (isReady === true) {
        // send a `ready` event to the server
        fetchRetry(serverUrl() + '/events', {
          cache: 'no-cache',  // expects ETags and If-Modified-Since / If-None-Match
          method: 'put',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({taskId: t, event: 'ready'})
        }).then(response => {
          //console.log(response.json())
        }).catch(error => {
          console.error(error)
        })

        tasks[t].ready = true
        // todo: reschedule .start based on current time & manual scheduling
        const index = originalData.map((n) => n[0]).indexOf(String(t))
        originalData[index][8] = 'yes'
      }
    })

    const completedIndex = originalData.map((n) => n[0]).indexOf(String(completedId))
    originalData[completedIndex][10] = 'yes'

    this.setState({
      tasks: tasks,
      originalData: originalData,
      nonce: this.state.nonce + 1
    }, () => {
      this.moveTaskBack(completedId, tasks)
      this.onSelectPerson(this.state.personFilter ? this.state.personFilter : {value: 'No filter', label: 'No filter'}, false)
      this.drawBoard(this.state.people, this.state.tasks)
    })
  }

  onSubscribe(person, targetTaskId = false) {
    let tasks = this.state.tasks

    let taskId = targetTaskId
    if (taskId === false) {
      taskId = this.state.currentTask.taskId
    }

    let body = {taskId: taskId, personId: person.value}
    if (tasks[taskId].person === person.value) {
      body['isOwner'] = true
    }

    // if the person is already subscribed and we click them, they are REMOVED
    // (the owner cannot be removed)
    let method = 'post'
    if (tasks[taskId].subscribers.has(person.value)) {
      method = 'delete'
      if (tasks[taskId].person === person.value) {
        console.error('Warning: owners cannot be unsubscribed from their own events.')
        return  // we don't ever want to remove owners
      }
    }

    fetchRetry(serverUrl() + '/subscriptions', {
      cache: 'no-cache',  // expects ETags and If-Modified-Since / If-None-Match
      method: method,
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(response => {
    }).catch(error => {
        console.error(error)
    })

    if (method === 'post') {
      tasks[taskId].subscribers.add(person.value)
    } else {
      tasks[taskId].subscribers.delete(person.value)
    }
 
    this.setState({
      tasks: tasks
    })
  }

  onSubscribeToCategory(person, category) {
    let tasks = this.state.tasks

    const categoryTasks = Object.values(tasks).filter(t => {
      return (t.category === category)
    })

    let subscribing = true
    let method = 'post'

    // if we're already subscribed to all tasks, then we'll be unsubscribing
    if (Object.values(categoryTasks).map(t => {
      return (t.subscribers.has(person.value))
    }).every(i => {return i})) {
      subscribing = false
      method = 'delete'
    }

    if (subscribing) {
      console.log('subscribing', person.value, 'to', category)
    } else {
      console.log('unsubscribing', person.value, 'from', category)
    }

    categoryTasks.forEach(t => {
      let taskId = t.taskId

      if (tasks[taskId].person === person.value) {
        return  // we can ignore task owners; they stay subscribed by default
      }

      let body = {taskId: taskId, personId: person.value}

      fetchRetry(serverUrl() + '/subscriptions', {
        cache: 'no-cache',  // expects ETags and If-Modified-Since / If-None-Match
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      }).then(response => {
      }).catch(error => {
          console.error(error)
      })

      if (method === 'post') {
        tasks[taskId].subscribers.add(person.value)
      } else {
        tasks[taskId].subscribers.delete(person.value)
      }
    })

    this.setState({
      tasks: tasks
    })
  }

  onSelectCategory(option, triggered = true) {
    let chosenTasks = [] 
    let options = this.state.categoryFilters
    if (triggered && options.has(option.value)) {
      options.delete(option.value)
      if (options.size === 0) {
        option = {label: 'No filter', value: 'No filter'}
      }
    } else {
      options.add(option.value)
    }
    let filteredData = [this.state.originalData[0]]

    this.state.originalData.forEach((i, index) => {
      if (index > 0 && options.has(i[1]) && !chosenTasks.includes(i[0])) {
        filteredData.push(i)
        chosenTasks.push(i[0])
      }
      if (index > 0 && this.state.includePre && this.state.tasks[parseInt(i[0], 10)].isPrerequisiteOf.length > 0) {
        this.state.tasks[parseInt(i[0], 10)].isPrerequisiteOf.forEach((p, pIndex) => {
          if (options.has(this.state.tasks[p].category) && !chosenTasks.includes(i[0])) {
            filteredData.push(i)
            chosenTasks.push(i[0])
          }
        })
      }
      if (index > 0 && this.state.includePost && this.state.tasks[parseInt(i[0], 10)].prerequisites.length > 0) {
        this.state.tasks[parseInt(i[0], 10)].prerequisites.forEach((p, pIndex) => {
          if (this.state.tasks[p] && options.has(this.state.tasks[p].category) && !chosenTasks.includes(i[0])) {
            filteredData.push(i)
            chosenTasks.push(i[0])
          }
        })
      }
    })

    if (this.state.readyOnly) {
      if (option.value === 'No filter') {
        filteredData = this.state.originalData
      }

      let placeholder = [filteredData[0]]
      filteredData.forEach((i, index) => {
        if (index > 0 && i[8] === 'yes') {
          placeholder.push(i)
        }
      })
      filteredData = placeholder

      if (this.state.noCompleted) {
        let placeholder = [filteredData[0]]
        filteredData.forEach((i, index) => {
          if (index > 0 && i[10] !== 'yes') {
            placeholder.push(i)
          }
        })
        filteredData = placeholder 
      }

      this.setState({
          categoryFilter: (option.value === 'No filter' ? null : option),
          categoryFilters: (option.value === 'No filter' ? new Set() : options),
          categoryFilteredData: filteredData
        }, () => {
          this.onSelectPerson(this.state.personFilter ? this.state.personFilter : {label: 'No filter', value: 'No filter'}, false)
        })
    } else {
      if (option.value === 'No filter') {
        filteredData = this.state.originalData
      }

      if (this.state.noCompleted) {
        let placeholder = [filteredData[0]]
        filteredData.forEach((i, index) => {
          if (index > 0 && i[10] !== 'yes') {
            placeholder.push(i)
          }
        })
        filteredData = placeholder 
      }

      this.setState({
        categoryFilter: (option.value === 'No filter' ? null : option),
        categoryFilters: (option.value === 'No filter' ? new Set() : options),
          categoryFilteredData: filteredData
      }, () => {
        this.onSelectPerson(this.state.personFilter ? this.state.personFilter : {label: 'No filter', value: 'No filter'}, false)
      })
    }
  }

  onSelectPerson(option, triggered = true) {
    // filter, first by person (adding in pre/post) then by ready
    let chosenTasks = []
    let options = this.state.personFilters
    if (triggered && options.has(option.value)) {
      options.delete(option.value)
      if (options.size === 0) {
        option = {label: 'No filter', value: 'No filter'}
      }
    } else {
      options.add(option.value)
    }
    let filteredData = [this.state.categoryFilteredData[0]]
    this.state.categoryFilteredData.forEach((i, index) => {
      if (index > 0 && options.has(i[3]) && !chosenTasks.includes(i[0])) {
        filteredData.push(i)
        chosenTasks.push(i[0])
      }
      if (index > 0 && this.state.includePre && this.state.tasks[parseInt(i[0], 10)].isPrerequisiteOf.length > 0) {
        this.state.tasks[parseInt(i[0], 10)].isPrerequisiteOf.forEach((p, pIndex) => {
          if (options.has(this.state.tasks[p].person) && !chosenTasks.includes(i[0])) {
            filteredData.push(i)
            chosenTasks.push(i[0])
          }
        })
      }
      if (index > 0 && this.state.includePost && this.state.tasks[parseInt(i[0], 10)].prerequisites.length > 0) {
        this.state.tasks[parseInt(i[0], 10)].prerequisites.forEach((p, pIndex) => {
          if (options.has(this.state.tasks[p].person) && !chosenTasks.includes(i[0])) {
            filteredData.push(i)
            chosenTasks.push(i[0])
          }
        })
      }
    })

    if (this.state.readyOnly) {
      if (option.value === 'No filter') {
        filteredData = this.state.categoryFilteredData
      }

      let placeholder = [filteredData[0]]
      filteredData.forEach((i, index) => {
        if (index > 0 && i[8] === 'yes') {
          placeholder.push(i)
        }
      })
      filteredData = placeholder

      this.setState({
          personFilter: (option.value === 'No filter' ? null : option),
          personFilters: (option.value === 'No filter' ? new Set() : options),
          filteredData: filteredData,
          sortedData: sortBy(this.state.sortType, filteredData, this.state.tasks)
        })
    } else {
      this.setState({
        personFilter: (option.value === 'No filter' ? null : option),
        personFilters: (option.value === 'No filter' ? new Set() : options),
        filteredData: (option.value === 'No filter' ? this.state.categoryFilteredData : filteredData),
        sortedData: (option.value === 'No filter' ? sortBy(this.state.sortType, this.state.categoryFilteredData, this.state.tasks) : sortBy(this.state.sortType, filteredData, this.state.tasks))
      })
    }
  }

  togglePreCheckbox(event) {
    this.setState({
      includePre: event.target.checked
    }, () => {
      this.onSelectCategory(this.state.categoryFilter ? this.state.categoryFilter : {value: 'No filter', label: 'No filter'}, false)
    })
  }

  togglePostCheckbox(event) {
    this.setState({
      includePost: event.target.checked
    }, () => {
      this.onSelectCategory(this.state.categoryFilter ? this.state.categoryFilter : {value: 'No filter', label: 'No filter'}, false)
    })
  }

  toggleReadyCheckbox(event) {
    this.setState({
      readyOnly: event.target.checked
    }, () => {
      this.onSelectCategory(this.state.categoryFilter ? this.state.categoryFilter : {value: 'No filter', label: 'No filter'}, false)
    })
  }

  toggleNoCompletedCheckbox(event) {
    this.setState({
      noCompleted: event.target.checked
    }, () => {
      //console.log(this.state.noCompleted)
      this.onSelectCategory(this.state.categoryFilter ? this.state.categoryFilter : {value: 'No filter', label: 'No filter'}, false)
    })
  }

  sortByStart(event) {
    this.setState({
      sortByStart: event.target.checked,
      sortByOriginalStart: false,
      sortType: !this.state.sortByStart ? 'startTime' : 'taskId',
      nonce: this.state.nonce + 1
    }, () => {
      //console.log(this.state.sortByStart)
      this.onSelectCategory(this.state.categoryFilter ? this.state.categoryFilter : {value: 'No filter', label: 'No filter'}, false)
    })    
  }

  sortByOriginalStart(event) {
    this.setState({
      sortByStart: false,
      sortByOriginalStart: event.target.checked,
      sortType: !this.state.sortByOriginalStart ? 'originalStartTime' : 'taskId',
      nonce: this.state.nonce + 1
    }, () => {
      //console.log(this.state.sortByOriginalStart)
      this.onSelectCategory(this.state.categoryFilter ? this.state.categoryFilter : {value: 'No filter', label: 'No filter'}, false)
    })    
  }

  isSubscribedToTask(person, taskOwner, taskSubscribers) {
    if (person === taskOwner) {
      return <span style={{color: 'navy'}} >{person + ' (subscribed — owner)'}</span>
    } else if (taskSubscribers.has(person)) {
      return <span style={{color: 'green'}} >{person + ' (subscribed)'}</span>
    } else {
      return <span style={{color: 'red'}} >{person + ' (not subscribed)'}</span>
    }
  }

  isSubscribedToCategory(person, category, tasks) {
    const categoryTasks = Object.values(tasks).filter(t => {
      return (t.category === category)
    })
    if (Object.values(categoryTasks).map(t => {
      return (t.subscribers.has(person))
    }).every(i => {return i})) {
      return <span style={{color: 'green'}} >{person + ' (subscribed)'}</span>
    } else {
      return <span style={{color: 'red'}} >{person + ' (not subscribed)'}</span>
    }
  }

  isFiltered(item, items) {
    if (items.has(item)) {
      return <span style={{color: 'green'}} >{item + ' (selected)'}</span>
    } else {
      return item
    }
  }

  render() {
    return (
      <div className='App'>
        <header className='App-header'>
          <h1 className='App-title'>
            CONVERSIONATOR {(
              (this.state.tasks && Object.keys(this.state.tasks).length > 0) ?
              ' - ' + String(Math.floor(
                100 * Object.values(this.state.tasks).filter(t => {
                  return t.completed
                }).length / Object.keys(this.state.tasks).length
              )) + '%' : ''
            )}
          </h1>
        </header>

        <Tabs>
          <TabList>
            <Tab>Task board</Tab>
            <Tab>Task list</Tab>
            <Tab>Categories</Tab>
          </TabList>

          <TabPanel
            forceRender={true}
          >
            <Measure bounds onResize={(contentRect) => {
                this.setState({ dimensions: contentRect.bounds })
              }}
            >
              {({ measureRef }) =>
                <div ref={measureRef}>
                  <MultiGrid
                    nonce={this.state.nonce}
                    cellRenderer={this.cellRenderer}
                    columnWidth={cache.columnWidth}
                    deferredMeasurementCache={cache}
                    columnCount={this.state.data[0].length}
                    fixedColumnCount={1}
                    fixedRowCount={1}
                    height={Math.max(
                              Math.max(
                                document.documentElement.clientHeight,
                                window.innerHeight || 0
                              ) - 375,
                              100
                            )}
                    rowHeight={25}
                    rowCount={this.state.data.length}
                    width={this.state.dimensions.width}
                    currentTask={this.state.currentTask}
                  />
                </div>
              }
            </Measure>
            <div style={{paddingTop: '2%', paddingLeft: '20%', paddingRight: '20%', paddingBottom: '2%'}}>
              {(
                this.state.currentTask ?
                <TaskDetails
                  taskId={this.state.currentTask.taskId}
                  name={this.state.currentTask.name}
                  category={this.state.currentTask.category}
                  owner={this.state.currentTask.person}
                  prerequisites={this.state.currentTask.prerequisites}
                  followUps={this.state.currentTask.isPrerequisiteOf}
                  startTime={moment(this.state.currentTask.start).format('ddd, MMMM Do [at] h:mm a')}
                  endTime={moment(this.state.currentTask.finish).format('ddd h:mm a')}
                  duration={humanizeDuration(moment.duration(
                    this.state.currentTask.duration, 'minutes'))}                  
                  scheduledStartTime={
                    moment(this.state.currentTask.originalStart)
                    .format('ddd, MMMM Do [at] h:mm a')}
                  realizedStartTime={
                    moment(this.state.currentTask.start)
                    .format('ddd, MMMM Do [at] h:mm a')}
                  startSchedule={this.state.currentTask.startSchedule}
                  scheduledEndTime={
                    moment(this.state.currentTask.originalFinish)
                    .format('ddd h:mm a')}
                  realizedEndTime={
                    moment(this.state.currentTask.finish)
                    .format('ddd h:mm a')}
                  endSchedule={this.state.currentTask.finishSchedule}
                  scheduledDuration={humanizeDuration(moment.duration(
                    this.state.currentTask.originalDuration, 'minutes'))}
                  realizedDuration={humanizeDuration(moment.duration(
                    this.state.currentTask.duration, 'minutes'))}
                  durationSchedule={humanizeSchedule(this.state.currentTask.durationSchedule, true)}
                  notes={this.state.currentTask.description}
                  taskReady={this.state.currentTask.ready}
                  taskStarted={this.state.currentTask.started}
                  taskCompleted={this.state.currentTask.completed}
                  onTaskStarted={this.onStart}
                  onTaskCompleted={this.onCompleted}
                  people={this.state.people}
                  subscribers={this.state.currentTask.subscribers}
                  hasSubscribed={this.isSubscribedToTask}
                  taskSubscribed={this.onSubscribe}
                  onTaskSelected={this.onTaskClick}
                /> :
                'Select a task...'
              )}
            </div>
          </TabPanel>

          <TabPanel
            //forceRender={true}  // this seems to mangle the colum autosizing
          >
            <Measure bounds onResize={(contentRect) => {
                this.setState({ dimensions: contentRect.bounds })
              }}
            >
              {({ measureRef }) =>
                <div ref={measureRef}>
                  <div>
                    <div style={{width: '25%', display: 'inline-block', paddingLeft: '1%'}}>
                      <Dropdown
                        options={['No filter'].concat(Array.from(this.state.categories).sort().map(category => {
                          return ({
                            value: category,
                            label: this.isFiltered(category, this.state.categoryFilters)
                          })
                        }))}
                        //options={['No filter'].concat(Array.from(this.state.categories).sort())}
                        onChange={this.onSelectCategory}
                        value={this.state.categoryFilter}
                        placeholder='Filter by category' />
                    </div>
                    <div style={{width: '25%', display: 'inline-block', paddingLeft: '1%', paddingRight: '3%'}}>
                      <Dropdown
                        options={['No filter'].concat(Object.keys(this.state.people).sort().map(person => {
                          return ({
                            value: person,
                            label: this.isFiltered(person, this.state.personFilters)
                          })
                        }))}
                        //options={['No filter'].concat(Object.keys(this.state.people).sort())}
                        onChange={this.onSelectPerson}
                        value={this.state.personFilter}
                        placeholder='Filter by person' />
                    </div>
                    <div style={{display: 'inline-block', position: 'relative', bottom: '20%', transform: 'translateY(-20%)'}}>
                      <div style={{display: 'inline-block'}}>
                        <input type='checkbox' id='pre' checked={this.state.includePre} onChange={this.togglePreCheckbox}/>
                        <label>Include prerequisites&nbsp;&nbsp;&nbsp;</label>
                      </div>
                      <div style={{display: 'inline-block'}}>
                        <input type='checkbox' id='post' checked={this.state.includePost} onChange={this.togglePostCheckbox}/>
                        <label>Include follow-up tasks&nbsp;&nbsp;&nbsp;</label>
                      </div>
                      <div style={{display: 'inline-block'}}>
                        <input type='checkbox' id='ready' checked={this.state.readyOnly} onChange={this.toggleReadyCheckbox}/>
                        <label>Only show ready tasks&nbsp;&nbsp;&nbsp;</label>
                      </div>
                      <div style={{clear: 'both', padding: '2x'}} />
                      <div style={{display: 'inline-block'}}>
                        Sort by:&nbsp;&nbsp;&nbsp;
                      </div>
                      <div style={{display: 'inline-block'}}>
                        <input type='checkbox' id='pre' checked={this.state.sortByStart} onChange={this.sortByStart}/>
                        <label>start time&nbsp;&nbsp;&nbsp;</label>
                      </div>
                      <div style={{display: 'inline-block'}}>
                        <input type='checkbox' id='post' checked={this.state.sortByOriginalStart} onChange={this.sortByOriginalStart}/>
                        <label>original start time&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                      </div>
                      <div style={{display: 'inline-block'}}>
                        <input type='checkbox' id='noCompleted' checked={this.state.noCompleted} onChange={this.toggleNoCompletedCheckbox}/>
                        <label>Do not show completed tasks&nbsp;&nbsp;&nbsp;</label>
                      </div>                      
                    </div>
                  </div>
                  <MultiGrid
                    nonce={this.state.nonce}
                    cellRenderer={this.taskCellRenderer}
                    columnWidth={cacheTwo.columnWidth}
                    deferredMeasurementCache={cacheTwo}
                    columnCount={this.state.filteredData[0].length}
                    fixedColumnCount={1}
                    fixedRowCount={1}
                    height={Math.max(
                              Math.max(
                                document.documentElement.clientHeight,
                                window.innerHeight || 0
                              ) - 416,
                              100
                            )}
                    rowHeight={25}
                    rowCount={this.state.filteredData.length}
                    width={this.state.dimensions.width}
                    currentTask={this.state.currentTask}
                  />
                </div>
              }
            </Measure>        
            <div style={{paddingTop: '2%', paddingLeft: '20%', paddingRight: '20%', paddingBottom: '2%'}}>
              {(
                this.state.currentTask ?
                <TaskDetails
                  taskId={this.state.currentTask.taskId}
                  name={this.state.currentTask.name}
                  category={this.state.currentTask.category}
                  owner={this.state.currentTask.person}
                  prerequisites={this.state.currentTask.prerequisites}
                  followUps={this.state.currentTask.isPrerequisiteOf}
                  startTime={moment(this.state.currentTask.start).format('ddd, MMMM Do [at] h:mm a')}
                  endTime={moment(this.state.currentTask.finish).format('ddd h:mm a')}
                  duration={humanizeDuration(moment.duration(
                    this.state.currentTask.duration, 'minutes'))}
                  scheduledStartTime={
                    moment(this.state.currentTask.originalStart)
                    .format('ddd, MMMM Do [at] h:mm a')}
                  realizedStartTime={
                    moment(this.state.currentTask.start)
                    .format('ddd, MMMM Do [at] h:mm a')}
                  startSchedule={this.state.currentTask.startSchedule}
                  scheduledEndTime={
                    moment(this.state.currentTask.originalFinish)
                    .format('ddd h:mm a')}
                  realizedEndTime={
                    moment(this.state.currentTask.finish)
                    .format('ddd h:mm a')}
                  endSchedule={this.state.currentTask.finishSchedule}
                  scheduledDuration={humanizeDuration(moment.duration(
                    this.state.currentTask.originalDuration, 'minutes'))}
                  realizedDuration={humanizeDuration(moment.duration(
                    this.state.currentTask.duration, 'minutes'))}
                  durationSchedule={humanizeSchedule(this.state.currentTask.durationSchedule, true)}
                  notes={this.state.currentTask.description}
                  taskReady={this.state.currentTask.ready}
                  taskStarted={this.state.currentTask.started}
                  taskCompleted={this.state.currentTask.completed}
                  onTaskStarted={this.onStart}
                  onTaskCompleted={this.onCompleted}
                  people={this.state.people}
                  subscribers={this.state.currentTask.subscribers}
                  hasSubscribed={this.isSubscribedToTask}
                  taskSubscribed={this.onSubscribe}
                  onTaskSelected={this.onTaskClick}
                /> :
                'Select a task...'
              )}
            </div>
          </TabPanel>
          <TabPanel>
            <CategoryTab
              categories={this.state.categories}
              tasks={this.state.tasks}
              people={this.state.people}
              hasSubscribed={this.isSubscribedToCategory}
              categorySubscribed={this.onSubscribeToCategory}
            />
          </TabPanel>
        </Tabs>
      </div>
    )
  }
}

export default App


// WEBPACK FOOTER //
// ./src/App.js